import { ReportDoc } from "../api";
import { RosterEntry } from "./combatLogParser";

/**
 * Build a player-name -> {class, spec, icon} map from a loaded report.
 *
 * The combat log only gives us names; the WCL report already knows each
 * player's class (metric rows carry `type` = class, `icon` = spec). We union
 * those rows across every metric block so we catch players that only appear in
 * one table (e.g. a healer absent from damage-done but present in damage-taken).
 */
export function rosterFromReport(report: ReportDoc): Record<string, RosterEntry> {
  const out: Record<string, RosterEntry> = {};

  const ingest = (rows: Record<string, unknown>[] | undefined) => {
    for (const row of rows ?? []) {
      const name = typeof row.name === "string" ? row.name : null;
      const type = typeof row.type === "string" ? row.type : null;
      if (!name || !type) continue;
      // First class seen for a name wins; only fill missing spec icons later.
      if (!out[name]) {
        out[name] = {
          class: type,
          icon: typeof row.icon === "string" ? row.icon : null,
        };
      } else if (!out[name].icon && typeof row.icon === "string") {
        out[name].icon = row.icon;
      }
    }
  };

  for (const block of Object.values(report.metrics ?? {})) {
    ingest(block?.rows);
  }
  for (const byMetric of Object.values(report.metricsByFight ?? {})) {
    for (const block of Object.values(byMetric ?? {})) {
      ingest(block?.rows);
    }
  }
  return out;
}
